import {formatIsraeliMobileDisplay} from '@sollapay/utils';

import {sanitizeDigits} from '../../lib/sanitize-digits';
import {FieldInput} from '../FieldInput';
import {Icon} from '../Icon';

import type {FieldInputProps} from '../FieldInput';
import type {ChangeEvent} from 'react';

export interface PhoneNumberFieldProps extends Omit<
  FieldInputProps,
  'value' | 'onChange' | 'inputMode' | 'type' | 'maxLength'
> {
  value: string;
  /** Omit for a read-only/display-only field (e.g. paired with `disabled`). */
  onChange?: (raw: string) => void;
}

const ISRAELI_MOBILE_LENGTH = 10;

/**
 * Israeli mobile number field: masks as `050-1234567` while typing, but reports the
 * normalized 10-digit value (e.g. `"0501234567"`) to `onChange` for storage.
 */
export function PhoneNumberField({
  value,
  onChange,
  startAdornment,
  ...fieldInputProps
}: PhoneNumberFieldProps) {
  return (
    <FieldInput
      {...fieldInputProps}
      startAdornment={startAdornment ?? <Icon name="phone" className="size-4" />}
      value={formatIsraeliMobileDisplay(value)}
      onChange={
        onChange
          ? (e: ChangeEvent<HTMLInputElement>) =>
              onChange(sanitizeDigits(e.target.value, ISRAELI_MOBILE_LENGTH))
          : undefined
      }
      inputMode="tel"
    />
  );
}
